import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { format, differenceInYears } from 'date-fns'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string | Date, fmt = 'dd MMM yyyy') {
  return format(new Date(date), fmt)
}

export function calculateAge(dob: string | Date) {
  return differenceInYears(new Date(), new Date(dob))
}

export function getInitials(firstName: string, lastName: string) {
  return `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase()
}

export const STAGE_LABELS: Record<string, string> = {
  STAGE_1_FOUNDATION: 'Foundation (0–3)',
  STAGE_2_EARLY_CHILDHOOD: 'Early Childhood (4–6)',
  STAGE_3_LOWER_PRIMARY: 'Lower Primary (7–9)',
  STAGE_4_UPPER_PRIMARY: 'Upper Primary (10–12)',
  STAGE_5_LOWER_SECONDARY: 'Lower Secondary (13–15)',
  STAGE_6_UPPER_SECONDARY: 'Upper Secondary (16–18)',
}

// Must match seed data domain colours (Amendment 1.B)
export const DOMAIN_COLOURS: Record<string, string> = {
  CHARACTER_AND_FAITH:         '#8B4513',
  COMMUNICATION_AND_LANGUAGES: '#2563EB',
  PROBLEM_SOLVING_AND_STEM:    '#7C3AED',
  PLANNING_AND_STRATEGY:       '#0891B2',
  LIFE_SKILLS_AND_ENVIRONMENT: '#16A34A',
  PHYSICAL_WELLNESS:            '#DC2626',
}

